import { Injectable } from "@angular/core";
import * as moment from "moment";
import { SignalRConnection } from "ng2-signalr";
import { UserPreference } from "../../models/UserPreference";
import { errorMessages } from "../../settings";
import { CommonService } from "../common.service";
import { DashboardService } from "../dashboard.service";
import { WidgethelperService } from "../widgethelper.service";
import { BaseService } from "./base.service";

@Injectable()
export class MhemessagesService extends BaseService{

  constructor(
    private _dashboardService: DashboardService,
    private _commonService: CommonService,
    private _widgetHelper: WidgethelperService
  ) { 
    super();
  }

  init(widget: any) {
    this._widgetHelper.CreateHub(widget)
    this.DisplayData(widget);
  }

  DisplayData(widget: any) {
    widget.hub.listenFor("broadcastMheMessages").subscribe(
      (result: any) => {
        console.log("broadcastMheMessages", result);
        let resultwid;
        let resultcreationtime;
        let lastUpdatedTime;

        if (result && result.length > 0) {
          //console.log(result[0].IsNoDataFound);
          widget.IfNoDataFound = result[0].IsNoDataFound;
          resultwid = result[0].widgetid;
          resultcreationtime = result[0].widgetcreationtime;
          lastUpdatedTime = result[0].LastUpdateTime;
        }
        else {
          widget.errorMessage = errorMessages.noWidgetData;
        }

        if (resultwid == widget.widgetId && resultcreationtime == widget.widgetcreationtime) {
          widget.dataLoaded = false;
          widget.chartOptions = this.chartOptions();
          widget.errorMessage = null;

          let Report_Periods = [];
          let mheMessages = result.map(function (item) { return item.MHE_MESSAGE })
                            .filter(this._widgetHelper.unique)
                            .sort(function (a, b) { return a.toLowerCase() < b.toLowerCase() ? -1 : 1; });
          result.sort(function (a, b) { return a.MHE_MESSAGE.toLowerCase() < b.MHE_MESSAGE.toLowerCase() ? -1 : 1; });
          for (let i = 0; i < mheMessages.length; i++) {
            let groupedKpis = result.filter(x => x.MHE_MESSAGE == mheMessages[i]);
            let kpis = []
            groupedKpis.forEach(element => {
              let rptdate = (element.YEAR_NUMBER + ' ' + element.MONTH_ABBR_NAME);
              if (rptdate != '' && Report_Periods.indexOf(rptdate) == -1) {
                Report_Periods.push(rptdate);
              }

              kpis.push([rptdate, element.MESSAGES_COUNT]);
            });

            this.addDataSeries(widget.chartOptions, kpis, mheMessages[i], 'bar');
          }

          widget.chartOptions.yAxis[0].axisLabel.rotate = 30;
          widget.chartOptions.xAxis.data = Report_Periods;

          if (widget.IfNoDataFound) {
            widget.errorMessage = errorMessages.noWidgetData;
          }
          else {
            widget.errorMessage = null;
          }
        }
        widget.dataLoaded = true;
        this._commonService.lastUpdatedTime = lastUpdatedTime;
        
      },
      err => {
        console.log("listenFor broadcastMheMessages error", err);
      }
    );
  }

}



// WEBPACK FOOTER //
// ./src/app/services/widgets/mhemessages.service.ts